/**
 * Initiative 14 Wave E1 — structured dataLayer pushes for GTM (Holistika Research).
 * Use alongside existing gtag events; keep event names aligned with env_tech_dtp_243 / Growth owner.
 *
 * Rules:
 *   - Event names here MUST match the GTM trigger names configured by the Growth owner.
 *   - Never push PII (email, phone, full name, message body) into the dataLayer.
 *   - Always include an `event_id` so Meta/GA server-side sends can deduplicate later.
 */

// Canonical Window.dataLayer declaration lives in types/global.d.ts.

export type GtmBusinessEvent = {
  event: string;
  /** Use for Meta browser/server deduplication when dual-firing */
  event_id?: string;
  /** Non-PII business context */
  form_type?: string;
  content_topic?: string;
  lead_score_bucket?: string;
};

function pushPayload(payload: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(payload);
}

/** Push a named event after GTM has initialized the dataLayer */
export function pushGtmEvent(e: GtmBusinessEvent) {
  pushPayload({
    event: e.event,
    ...(e.event_id ? { event_id: e.event_id } : {}),
    ...(e.form_type ? { form_type: e.form_type } : {}),
    ...(e.content_topic ? { content_topic: e.content_topic } : {}),
    ...(e.lead_score_bucket ? { lead_score_bucket: e.lead_score_bucket } : {}),
  });
}

/** Example: lead intent (aligns with existing lead_intent gtag usage) */
export function pushLeadIntent(opts: {
  formType?: string;
  eventId?: string;
}) {
  pushGtmEvent({
    event: "lead_intent",
    form_type: opts.formType,
    event_id: opts.eventId,
  });
}
